import(/* webpackMode: "eager" */ "/codebuild/output/src512597308/src/app/page.js");
